import { ConfigProvider } from 'antd';
import type { Locale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import ruRU from 'antd/locale/ru_RU';
import dayjs from 'dayjs';
import { PropsWithChildren, useEffect } from 'react';
import 'dayjs/locale/ru';

import { DEFAULT_LOCALE, UserLocale } from '@/shared/config';
import { useAppSelector } from '@/shared/hooks';

import { userModel } from '@/entities/user';

const ANTD_LOCALES: Record<UserLocale, Locale> = {
  'en-US': enUS,
  ru: ruRU,
};

const DAYJS_LOCALES: Record<UserLocale, string> = {
  'en-US': 'en',
  ru: 'ru',
};

export const AntdConfigProvider = ({ children }: PropsWithChildren) => {
  const { locale } = useAppSelector(userModel.selectors.selectUserSettings);
  const userLocale: UserLocale = locale || DEFAULT_LOCALE;

  useEffect(() => {
    // antd DatePicker takes month and weekday names from the global dayjs locale.
    dayjs.locale(DAYJS_LOCALES[userLocale]);
  }, [userLocale]);

  return (
    <ConfigProvider
      locale={ANTD_LOCALES[userLocale]}
      theme={{ token: { colorPrimary: '#7564ed' } }}
    >
      {children}
    </ConfigProvider>
  );
};
